define('apps/course-intro/templates/regions/levels/content',['handlebars'], function(Handlebars) {

return Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<section class=\"hero\">\n    <h1>\n        Welcome to Earn<br/>\n        Your Future<sup>&reg;</sup> Digital Classroom.\n    </h1>\n    <span class=\"select-a-level\"></span>\n    <span class=\"infographic level-three spend\"></span>\n    <span class=\"infographic level-two interest\"></span>\n</section>\n\n<section class=\"levels clearfix\">\n</section>\n\n<footer>\n    <div class=\"logo\">\n        <img src=\"./static/img/brand/pwc-logo.svg\">\n    </div>\n</footer>\n";
  })

});
